export default __webpack_public_path__ + "static/wakacjepl-8d1e621ef2f5a39d1b6bb7f8f0255306.png";